module.exports = __webpack_public_path__ + "static/media/TopLeftBase.6649b4e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/Images/ButtonBases/TopLeftBase.png
// module id = 46
// module chunks = 0